$(document).ready(function(){
	var popupViewed = sessionStorage.getItem("popupViewed");

	if( !popupViewed ) {
		$('body').addClass('popup--active');
		$('body').attr('data-popup-open', true);
	}
	
	$("[data-close-popup]").click(function(e){
		// e.preventDefault();
		storePopupViewedProp();
	});

	function storePopupViewedProp() {
		$('body').removeClass('popup--active');
		$('body').removeAttr('data-popup-open', true);
		sessionStorage.setItem("popupViewed", true);
	}

    $(document).on('click', '[data-popup-open]', function() {
        storePopupViewedProp();
    });

	// $('body').on('click', '[data-popup-content]', function(e) {
	// 	e.stopPropagation();
	// });

	$(document).on('keyup', '[data-popup-open]', function(e) {
		(e.keyCode === 27 ? storePopupViewedProp() : null);
	});
});


// WEBPACK FOOTER //
// ./popup.js